const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '4rem' }}>
      <h2>404 - Page Not Found</h2>
    </div>
  );
};

export default NotFound;
